
export default {
	'щенки': '(до года)',
	'взрослые': '(от 1 до 6 лет)',
	'миниатюрный': '(до 3 кг)',
	'средний': '(10-20 кг)',
	'мелкий': '(4-10 кг)',
	'крупный': '(от 20 кг)',
}



// WEBPACK FOOTER //
// ./src/data/description.js